import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { fetchPaymentsData, payoutsCount } from './fetchPaymentsData/fetchPaymentsData';
import Pagination from '../../components/pagination/Pagination';
import EmptyPage from '../../components/empty-page/emptyPage';
import { approvePayoutData, disApprovePayoutData } from './handleApprove/handleApprove';

const SupPayments = () => {
    const [typeSel, setTypeSel] = useState('trip');
    const [status, setStatus] = useState('approved');
    const [offset, setOffset] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [paymentsData, setPaymentsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const limit = 10;
    const totalData = totalCount;
    const refresh = () => {
        setLoad(!load);
    };

    const tableHeader = [
        'Organizer Name',
        'Trip Name',
        'Trip Date',
        'Slots',
        'Payout Amount',
        'Commission',
        'Total Amount',
        'Action'
    ];

    useEffect(() => {
        if (!typeSel || !status) return;
        fetchPaymentsData(setLoading, setPaymentsData, typeSel, status, limit, offset);
    }, [limit, offset, typeSel, status, load]);

    useEffect(() => {
        if (!typeSel || !status) return;
        payoutsCount(setTotalCount, typeSel, status, setLoading);
    }, [typeSel, status]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffset(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const handleApprove = (id) => {
        approvePayoutData(typeSel, id, setLoading, refresh);
    };

    const handleDisapprove = (id) => {
        disApprovePayoutData(typeSel, id, setLoading, refresh);
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter'>
                <h1 className='supportHeader'>Payments</h1>
                <div>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={typeSel}
                        onChange={(e) => setTypeSel(e.target.value)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='trip'>Trip</option>
                        <option value='camp'>Camp</option>
                        <option value='guide'>Guide</option>
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <option value='approved'>Approved</option>
                        <option value='not-approved'>Not Approved</option>
                    </select>
                </div>
            </div>
            <div className='supDropdwonContainer'>
                {paymentsData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {paymentsData?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td>{row?.contentId?.organizerName ?? 'N/A'}</td>
                                            <td>{row?.contentId?.title ?? 'N/A'}</td>
                                            <td>{new Date(row.startDate).toDateString() ?? 'N/A'}</td>
                                            <td>{`${row.bookedSlots ?? 'N/A'}/${row.totalSlots ?? 'N/A'}`}</td>
                                            <td>{row?.payoutDetails?.amount ?? 'N/A'}</td>
                                            <td>{row?.payoutDetails?.commission ?? 'N/A'}</td>
                                            <td>{row?.payoutDetails?.totalAmount ?? 'N/A'}</td>
                                            <td>
                                                <button
                                                    className={`actBtn ${
                                                        row.approval === 'approved' ? 'billBtn' : 'payoutBtn'
                                                    } noWidth`}
                                                    onClick={() => {
                                                        row.approval === 'approved'
                                                            ? handleDisapprove(row._id)
                                                            : handleApprove(row._id);
                                                    }}
                                                >
                                                    {row.approval === 'approved' ? 'Disapprove' : 'Approve'}
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {paymentsData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {row?.contentId?.organizerName ?? 'N/A'}
                                        </p>
                                        <p className='bookingCardLabelDisplay'>
                                            <strong>{tableHeader[1]}:</strong> {row?.contentId?.title ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong>{' '}
                                            {new Date(row.startDate).toDateString() ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong>{' '}
                                            {`${row.bookedSlots ?? 'N/A'}/${row.totalSlots ?? 'N/A'}`}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong> {row?.payoutDetails?.amount ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[5]}:</strong> {row?.payoutDetails?.commission ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[6]}:</strong>{' '}
                                            {row?.payoutDetails?.totalAmount ?? 'N/A'}
                                        </p>
                                        <div className='sendMessageBtn'>
                                            <button
                                                className={`actBtn ${
                                                    row.approval === 'approved' ? 'billBtn' : 'payoutBtn'
                                                } noWidth`}
                                                onClick={() => {
                                                    row.approval === 'approved'
                                                        ? handleDisapprove(row._id)
                                                        : handleApprove(row._id);
                                                }}
                                            >
                                                {row.approval === 'approved' ? 'Disapprove' : 'Approve'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offset}
                    pageNumber={pageNumber}
                    limit={limit}
                />
            </div>
        </>
    );
};

export default SupPayments;
